var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000102514183399660796180000003932243958793786796_",
    transform: "translate(0.001 0.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000142862216889980288450000008852737050947343504_",
    transform: "translate(-0.001 -0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9403",
    d: "M24,1c12.7,0,23,10.3,23.1,23c-0.1,12.7-10.5,23-23.2,23C11.2,46.8,1,36.5,0.9,23.8C1.1,11.2,11.4,1,24,1z  M24.1,3.2C12.7,3.1,3.4,12.3,3.3,23.7c0,0.1,0,0.2,0,0.2C3.1,35.1,12,44.4,23.2,44.7c0.2,0,0.5,0,0.7,0 c11.3,0.2,20.6-8.7,20.8-20c0-0.2,0-0.4,0-0.6c0.1-11.4-9-20.7-20.4-20.8C24.2,3.2,24.1,3.2,24.1,3.2L24.1,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9404",
    d: "M26.4,26.4v6.1c-0.1,1.1,0.5,2.2,1.5,2.7c0.7,0.2,1.2,1,1,1.7c-0.2,0.8-0.9,1.3-1.7,1.2h-6.2 c-0.8,0-1.5-0.3-1.7-1.2c-0.2-0.7,0.2-1.5,1-1.7c1-0.4,1.6-1.5,1.5-2.6v-8.4c0.1-1.1-0.5-2.2-1.6-2.7c-0.7-0.2-1.1-1-0.9-1.7 c0.2-0.8,0.9-1.3,1.7-1.2c1.4,0,2.8,0,4.2,0c0.9,0,1.3,0.4,1.3,1.3C26.4,22.1,26.4,24.2,26.4,26.4L26.4,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9405",
    d: "M23.7,9.9c1.5,0,2.7,1.3,2.7,2.8c0,1.5-1.3,2.7-2.8,2.7c-1.4,0-2.6-1.2-2.6-2.6 C20.9,11.2,22.1,9.9,23.7,9.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.1f6c23abe5b99e755e9c939c73f20caa.svg";
export { ForwardRef as ReactComponent };